// Promotional posters already published by the café. Terms, dates and
// eligibility are set by the café; the site only displays the posters.
import o1 from "../../components/Image/images/1.png";
import o2 from "../../components/Image/images/2.png";
import o3 from "../../components/Image/images/3.png";
import o4 from "../../components/Image/images/4.png";
import o5 from "../../components/Image/images/5.png";
import pizza from "../../components/AnimatedCards/Media/pizza1.jpg";
import mocktails from "../../components/AnimatedCards/Media/mocktails1.jpg";
import kids from "../../components/AnimatedCards/Media/kids1.jpg";

export const offers = [
  { id: 1, src: o1, alt: "RollOver pizza offer poster: buy one get two free" },
  { id: 2, src: o2, alt: "RollOver pizza offer poster: one plus one regular pizza" },
  { id: 3, src: o3, alt: "RollOver pizza offer poster: one plus one regular veg pizza" },
  { id: 4, src: o4, alt: "RollOver pizza offer poster: one plus one medium pizza" },
  { id: 5, src: o5, alt: "RollOver pizza offer poster: flavour fun box of three pizzas" },
];

export const arrivals = [
  { id: "pizza", src: pizza, alt: "Pizza, new at RollOver", title: "Pizza", text: "Promotional launch; see the current offer posters." },
  { id: "mocktails", src: mocktails, alt: "Mocktails, new at RollOver", title: "Mocktails", text: "Chilled coolers listed under Beverages on the full menu.", to: "/menu/c/beverages" },
  { id: "kids", src: kids, alt: "Kids' treats at RollOver", title: "For the kids", text: "Cones and sundaes sized for small hands.", to: "/menu/c/waffle-cones" },
];

export const arrivalsIntro =
  "At RollOver we are always on the lookout for the latest trends and newest flavours to keep our customers coming back for more. These are the newest arrivals.";
